<template>
  <div class="">
    <img alt="" v-if="clickTab.dictValue === '10'"
         src="@/assets/img/home/system_management.jpg"
         class="home" />
    <img alt="" v-else-if="clickTab.dictValue === '20'"
         src="@/assets/img/home/learning_management.jpg"
         class="home" />
    <img alt="" v-else-if="clickTab.dictValue === '30'"
         src="@/assets/img/home/talent_development.jpg"
         class="home" />
    <img alt="" v-else-if="clickTab.dictValue === '40'"
         src="@/assets/img/home/report_management.jpg"
         class="home" />
    <img alt="" v-else-if="clickTab.dictValue === '50'"
         src="@/assets/img/home/resource_management.jpg"
         class="home" />
    <img alt="" v-else-if="clickTab.dictValue === '60'"
         src="@/assets/img/home/online_learning.jpg"
         class="home" />
    <img alt="" v-else
         src="@/assets/img/home/system_management.jpg"
         class="home" />
    <div v-show="false">
      <vue-ueditor-wrap :destroy="true"
                        v-model="ueditor"
                        :config="myConfig"></vue-ueditor-wrap>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clickTab: [],
      ueditor: '',
      myConfig: {
        autoHeightEnabled: false,
        initialFrameHeight: 240,
        initialFrameWidth: '100%',
        serverUrl: window.SITE_CONFIG['apiURL'] + '/sys/config/imgUpload' + `?token=${this.getStorage(this.GLOBAL.TOKEN)}`,
        UEDITOR_HOME_URL: '/UEditor/'
      }
    }
  },
  activated() {
    this.clickTab = this.getStorage('clickTab')
  },
  created() {
    this.$eventHub.$on(this.GLOBAL.HOME, (data) => {
      this.clickTab = this.getStorage('clickTab')
    })
  }
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
}
</style>
